<template lang="pug" src="./treatments.pug"></template>

<script>
import HeroPages from 'components/hero/hero-pages/hero-pages'
import TabsTreatmentOptions from 'components/tabs/tabs-treatment-options/tabs-treatment-options'

export default {
  computed: {
    props () {
      return this.$store.state.pages.treatments
    }
  },
  components: {
    HeroPages,
    TabsTreatmentOptions
  }
}
</script>



// WEBPACK FOOTER //
// treatments.vue?37e77e62